import { format } from "date-fns";
import React from "react";
import { View, Text } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { GlobalStyles } from "../style/Style";

type Props = {
    matchTitle?: string;
    groupTitle?: string;
    groupDate?: Date;
};

export const Group: React.FC<Props> = ({ matchTitle, groupTitle, groupDate, children }) => {
    const styles = useDynamicStyles(generateStyles);

    return (
        <>
            <View style={[styles.groupContainer, groupDate && styles.hasDate]}>
                {matchTitle && <Text style={[styles.matchTitle]}>{matchTitle}</Text>}
                {groupTitle && <Text style={[styles.groupTitle]}>{groupTitle}</Text>}
                {groupDate && <Text style={[styles.groupDate]}>{format(new Date(groupDate), "LLLL d, h:mm b")}</Text>}
            </View>
            <View style={styles.gamesContainer}>{children}</View>
        </>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        groupContainer: {
            minHeight: 36,
            borderTopLeftRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
            borderTopRightRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
            backgroundColor: () => EStyleSheet.value(GlobalStyles.PROP_HEADER),
            alignContent: "center",
            justifyContent: "center",
            textAlign: "center",
            paddingVertical: 10,
        },
        hasDate: {
            minHeight: 46,
        },
        matchTitle: {
            fontSize: 16,
            lineHeight: 16,
            color: () => EStyleSheet.value(GlobalStyles.PROP_HEADER_TEXT),
            fontFamily: () => EStyleSheet.value(GlobalStyles.HEADER_FONT),
        },
        groupTitle: {
            fontSize: 14,
            lineHeight: 18,
            paddingHorizontal: 10,
            fontWeight: "600",
            color: () => EStyleSheet.value(GlobalStyles.PROP_HEADER_TEXT),
        },
        groupDate: {
            fontSize: 12,
            lineHeight: 12,
            fontWeight: "400",
            color: () => EStyleSheet.value(GlobalStyles.PROP_HEADER_DATE),
        },
        gamesContainer: {
            padding: 10,
            borderTopWidth: 0,
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            borderColor: () => EStyleSheet.value(GlobalStyles.BORDER_COLOR),
            borderBottomLeftRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
            borderBottomRightRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
            marginBottom: 10,
        },
    });
};
